import { WritableAtom, atom, useAtom, useSetAtom } from "jotai";

export type CurrentActionTypes =
  | ""
  | "deliveryCost"
  | "newOrder"
  | "serviceCost"
  | "tip"
  | "customerPaysWith"
  | "clientModal"
  | "addRemarkModal"
  | "customerOrderHistoryModal"
  | "changeProductPrice"
  | "posSettings"
  | "emptyTheCart"
  | "posOrderDiscount"
  | "customProduct"
  | "posOrderDiscountCode"
  | "scanBarcode"
  | "printReceipt"
  | "openCustomerScreen"
  | "openCashDrawer"
  | "enterTableNumber"
  | "addTopping";

const posOrderCurrentActionAtom = atom<{
  name: CurrentActionTypes;
  action: (value: any) => void;
} | null>(null) as WritableAtom<
  {
    name: CurrentActionTypes;
    action: (value: any) => void;
  } | null,
  [
    {
      name: CurrentActionTypes;
      action: (value: any) => void;
    } | null,
  ],
  void
>;

const usePosOrderCurrentAction = () => {
  const atom = useAtom(posOrderCurrentActionAtom);
  return atom;
};

export const useSetPosOrderCurrentAction = () =>
  useSetAtom(posOrderCurrentActionAtom);

export default usePosOrderCurrentAction;
